import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import { AI_AGENT_LAUNCHER_TOOLTIP, AI_AGENT_TOKENS } from './AIAgentConstants';
import { AIAgentAvatarStarsWhiteIcon } from './components/AIAgentIcons';

interface Props {
  onOpen: () => void;
  launcherRef: React.RefObject<HTMLButtonElement>;
}

export default function AIAgentLauncher({ onOpen, launcherRef }: Props) {
  return (
    <Tooltip title={AI_AGENT_LAUNCHER_TOOLTIP} placement="left">
      <Fab
        ref={launcherRef}
        color="primary"
        aria-label={AI_AGENT_LAUNCHER_TOOLTIP}
        onClick={onOpen}
        sx={{
          position: 'fixed',
          bottom: 88,
          right: 16,
          zIndex: (theme) => theme.zIndex.speedDial,
          backgroundColor: AI_AGENT_TOKENS.primary,
          width: 56,
          height: 56,
          boxShadow: '0px 4px 12px rgba(45, 93, 231, 0.35)',
          '&:hover': {
            backgroundColor: AI_AGENT_TOKENS.primary,
            opacity: 0.92,
          },
        }}
      >
        <AIAgentAvatarStarsWhiteIcon size={24} />
      </Fab>
    </Tooltip>
  );
}
